<template>
    <span class="font-semibold text-green-100"><slot /></span>
</template>
